export const MAX_TITLE_LEN = 30;
export const MAX_DESCRIPTOR_LEN = 50;
export const MAX_THUMB_OPTIONS = 5;
